export enum SettingsTabEnum {
  replyEmail = "reply-email",
  password = "password",
}
